import allMeetingStatsSaga from './allMeetingStatsSaga'
import allExhibitorMeetingStatsSaga from './allExhibitorMeetingStatsSaga'
import exhibitorMeetingByDateSaga from './exhibitorMeetingByDateSaga'
import exhibitorMeetingCostsSaga from './exhibitorMeetingCostsSaga'
import exhibitorMeetingRatingsSaga from './exhibitorMeetingRatingsSaga'
import meetingByDateSaga from './meetingByDateSaga'
import meetingByOperatorSaga from './meetingByOperatorSaga'
import meetingCostsSaga from './meetingCostsSaga'
import meetingRatingsSaga from './meetingRatingsSaga'

const meetingStatisticsSagas = [
    allMeetingStatsSaga(),
    allExhibitorMeetingStatsSaga(),
    exhibitorMeetingByDateSaga(),
    exhibitorMeetingCostsSaga(),
    exhibitorMeetingRatingsSaga(),
    meetingByDateSaga(),
    meetingByOperatorSaga(),
    meetingCostsSaga(),
    meetingRatingsSaga()
]

export default meetingStatisticsSagas
